import { render } from "./BFormCheckbox.vue?vue&type=template&id=c71a85a6"
import script from "./BFormCheckbox.vue?vue&type=script&lang=js"
export * from "./BFormCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__